import { Button } from "common/components/ui/Button";
import useSubscriptionMutations from "common/datahooks/useSubscriptionMutations";
import { trackMetaPixel } from "common/helpers/utils";
import useSubscriptionPricing from "common/hooks/useSubscriptionPricing";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

export default function StartTrialButton() {
  const isDesktop = useTwBreakpoint("lg");
  const { plan } = useSubscriptionPricing("month", "user");
  const { relativeNavigate } = useWorkspaceNavigate();

  const { createSubscription, isCreatingSubscription } =
    useSubscriptionMutations();

  async function startTrial() {
    await createSubscription({
      planId: plan.id,
      type: "user",
      count: 1,
      paymentSourceId: null,
    });

    trackMetaPixel("trackCustom", "FreeTrialApp");
    relativeNavigate("onboarding?welcome-screen=true");
  }

  return (
    <Button
      size={isDesktop ? "sm" : "md"}
      isLoading={isCreatingSubscription}
      onClick={startTrial}
    >
      Start 7-day free trial
    </Button>
  );
}
